import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { GlassHouseBusinessCardStackBackgroundViewModel } from './glass-house-business-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import { GlassHouseCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-card-data';

@Component({
  selector: 'app-glass-house-business-card-stack-background',
  templateUrl: './glass-house-business-card-stack-background.component.html',
  styleUrls: ['./glass-house-business-card-stack-background.component.scss'],
  providers: [GlassHouseBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseBusinessCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: GlassHouseBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GlassHouseCardData;
}
